<template>
    <v-container>
        <v-lov-dialog title="选择角色" :width="800"
                      :fields="roleLovFields"
                      query-api="ROLE_QUERY"
                      v-model="showRoleLovDialog"
                      @cancel="showRoleLovDialog=false"
                      @ok="onAddRole"></v-lov-dialog>
        <v-lov-dialog title="选择用户" :width="800"
                      :fields="userLovFields"
                      query-api="USER_QUERY"
                      v-model="showUserLovDialog"
                      @cancel="showUserLovDialog=false"
                      @ok="onAddUser"></v-lov-dialog>
        <v-simple-form title="权限组信息">
            <template v-slot:toolbar>
                <v-btn text tile small color="rgba(0,0,0,.7)" @click="goBack">
                    <v-icon color="gray">mdi-step-backward</v-icon>
                    返回
                </v-btn>
                <v-btn text tile small color="rgba(0,0,0,.7)" @click="onSave">
                    <v-icon color="gray">mdi-content-save</v-icon>
                    保存
                </v-btn>
                <v-spacer/>
            </template>
            <template v-slot:content>
                <v-form-field x-large v-model="dataItem.name" label="权限组名称"></v-form-field>
                <v-form-textarea x-large v-model="dataItem.description" label="说明"></v-form-textarea>
            </template>
        </v-simple-form>
        <v-simple-form title="权限组成员" v-if="docId">
            <template v-slot:toolbar>
                <v-btn text tile small color="rgba(0,0,0,.7)" @click="showRoleLovDialog=true">
                    <v-icon color="gray">mdi-account-group</v-icon>
                    添加角色
                </v-btn>
                <v-btn text tile small color="rgba(0,0,0,.7)" @click="showUserLovDialog=true">
                    <v-icon color="gray">mdi-account</v-icon>
                    添加人员
                </v-btn>
                <v-spacer/>
            </template>
            <template v-slot:content>
                <v-page-data-table
                        seq
                        dense
                        hide-toolbar
                        hide-footer
                        title=""
                        key-name="id"
                        ref="permissionItem"
                        :fields="permissionItemFields"
                        :show-edit="false"
                        :query-params="permissionItemQueryParam"
                        query-api="PERMISSION_ITEM_QUERY"
                        delete-api="PERMISSION_ITEM_REMOVE">
                    <template v-slot:type="{item}">
                        {{item.type=='ROLE'?"角色":"用户"}}
                    </template>
                </v-page-data-table>
            </template>
        </v-simple-form>
    </v-container>
</template>

<script>

    import FndRoleLovFields from "./fields/FndRoleLov";
    import FndPermissionItemFields from "./fields/FndPermissionItem";
    import FndUserLovFields from "./fields/FndUserLov";

    export default {
        name: "ProjectDetail.vue",
        data() {
            return {
                docId: null,
                permissionItemFields: FndPermissionItemFields,
                roleLovFields: FndRoleLovFields,
                userLovFields: FndUserLovFields,
                showUserLovDialog: false,
                showRoleLovDialog: false,
                permissionItemQueryParam: {
                    permissionId: this.$route.query.id
                },
                dataItem: {
                    id: null,
                    name: null,
                    description: null
                }
            }
        },
        created() {
            this.docId = this.$route.query.id;
            if (this.docId) {
                this.queryDetail(this.docId);
            }
        },
        methods: {
            goBack() {
                this.$router.go(-1);
            },
            onSave() {
                this.$request
                    .request("PERMISSION_APPLY", this.dataItem)
                    .then((response) => {
                        this.$message.success("保存成功");
                        if (!this.docId) {
                            this.goBack();
                        }
                    });
            },

            queryDetail(id) {
                this.$request
                    .request("PERMISSION_DETAIL", {rowid: id})
                    .then(response => {
                        this.dataItem = response.data;
                    });
            },
            onAddRole(item) {
                let parameter = {
                    permissionId: this.docId,
                    type: 'ROLE',
                    targetId: item.id
                }
                this.$request
                    .request("PERMISSION_ITEM_APPLY", parameter)
                    .then((response) => {
                        this.$refs.permissionItem.query();
                    });
                this.showRoleLovDialog = false;
            },
            onAddUser(item) {
                let parameter = {
                    permissionId: this.docId,
                    type: 'USER',
                    targetId: item.id
                }
                this.$request
                    .request("PERMISSION_ITEM_APPLY", parameter)
                    .then((response) => {
                        this.$refs.permissionItem.query();
                    });
                this.showUserLovDialog = false;
            }
        }
    }
</script>
